import { LOGOUT, UNAUTHENTICATE } from '../../common/actions/auth';

import { fulfilled } from '../../common/reducers/utils/asyncActionNameSuffixes';
import { doGoogleSignOut } from '../../common/utils/auth/googleAuth';
import { clearFakeAuthData } from '../../common/actions/fakeAuth';
import { doFBSignOut } from '../../common/utils/auth/fbAuth';

const logoutMiddleware = (store) => (next) => (action) => {
  if (action.type === fulfilled(LOGOUT) || action.type === UNAUTHENTICATE) {
    // Figured if we logout, we can go ahead and log the user out from our app as well.
    doGoogleSignOut();
    doFBSignOut();
    store.dispatch(clearFakeAuthData());
  }

  return next(action);
};

export default logoutMiddleware;
